﻿(function() {
    "use strict";

    angular
        .module("app")
        .controller("ResetAccountController", ResetAccountController);

    ResetAccountController.$inject = ["$stateParams"]

    function ResetAccountController($stateParams) {
        var vm = this

        vm.user = {
            email: $stateParams.email || '',
            token: $stateParams.token || '',
        }
    }

})();
